<template>
  <vc-layout :class="['vue-swatch']" :spacing="8">
    <vc-col :span="16">
      <vc-text
        autocomplete="off"
        autocorrect="off"
        autocapitalize="off"
        spellcheck="false"
        type="text"
        icon-left="edit"
        :placeholder="lang.inputPlaceholder"
        :color="primaryColor"
        :name="`swatch-${index}`"
        @input="onInput"
        v-model="swatch.color" />
    </vc-col>
    <vc-col :span="8">
      <vc-button
        block
        size="small"
        @click="removeSwatch"
        :color="primaryColor"
        :class="['swatch-color']"
        :style="{backgroundColor: swatch.color}">
        <vc-icon>delete</vc-icon>
      </vc-button>
    </vc-col>
  </vc-layout>
</template>
<script>
export default {
  name: 'VueSwatch',
  data () {
    return {
      swatch: null,
      lang: {
        removeSwatch: 'Remove swatch',
        inputPlaceholder: 'Type hex color value'
      }
    }
  },
  props: {
    color: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    primaryColor: {
      type: String,
      required: false,
      default: 'primary'
    }
  },
  created () {
    this.swatch = this.color
  },
  methods: {
    removeSwatch () {
      this.$root.$emit('swatch:remove', {
        index: this.index
      })
    },
    onInput () {
      this.$root.$emit('swatch:input', {
        index: this.index,
        swatch: this.swatch
      })
    }
  }
}
</script>
<style>
.vue-swatch .vc-button
{
  margin-top: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/vue-swatch/index.vue